export type MoneybirdContactPreview = {
  id: string;
  company_name: string | null;
  firstname: string | null;
  lastname: string | null;
  email: string | null;
};

export function moneybirdContactDisplayName(
  c: MoneybirdContactPreview
): string {
  const cn = (c.company_name ?? "").trim();
  if (cn) return cn;
  const person = [c.firstname, c.lastname].filter(Boolean).join(" ").trim();
  if (person) return person;
  return (c.email ?? "").trim() || `Contact ${c.id}`;
}

function normalize(s: string): string {
  return s.toLowerCase().replace(/\s+/g, " ").trim();
}

function tokenize(s: string): string[] {
  return normalize(s)
    .split(/[^a-z0-9]+/)
    .filter((t) => t.length >= 2);
}

/**
 * Heuristic match score for sorting Moneybird contacts against an EFF company name.
 * Higher = better (roughly 0–100).
 */
export function scoreMoneybirdNameMatch(
  companyName: string,
  c: MoneybirdContactPreview
): number {
  const needle = normalize(companyName);
  if (!needle) return 0;
  const display = normalize(moneybirdContactDisplayName(c));
  if (!display) return 0;
  if (display === needle) return 100;
  if (display.includes(needle) || needle.includes(display)) return 88;

  const nt = tokenize(companyName);
  const dtArr = tokenize(display);
  const dt = new Set(dtArr);
  if (nt.length === 0) return 0;

  let hits = 0;
  for (const t of nt) {
    if (dt.has(t)) {
      hits += 1;
      continue;
    }
    let partial = false;
    for (const d of dtArr) {
      if (d.includes(t) || t.includes(d)) {
        partial = true;
        break;
      }
    }
    if (partial) hits += 0.72;
  }

  return (hits / nt.length) * 72;
}
